import {shiftWorkVI} from "./time-sheet/shift-assignment/vi";
import {ShiftScheduleVI} from "./time-sheet/shift-schedule/vi";
import {ShiftRegistrationVI} from "./time-sheet/shift-registration/vi";
import {CasualAndCompensatoryVI} from "./casual-and-compensatory/vi";
import {timeSheetVI} from "./time-sheet/timesheet/vi";

export const TimeKeepingVI = {
    ...shiftWorkVI,
    ...ShiftScheduleVI,
    ...ShiftRegistrationVI,
    ...CasualAndCompensatoryVI,
    ...timeSheetVI
}